// Import the shared popup close icon
import { CloseIcon } from "global/strich_icons/StrichIcons";

// Show the available Store types before opening their respective connection flows
const StoreChoicePopup = ({ onClose, onStrich, onEtsy, connectingEtsy }) => {

    // Close the chooser when the background is clicked
    const handleBackdropClick = (event) => {
        if (event.target === event.currentTarget) { onClose(); }
    };

    return (

        <div className="popup-overlay" onClick={handleBackdropClick}>

            <div className="popup-container popup-container--small store-choice-popup" role="dialog" aria-modal="true" aria-labelledby="store-choice-title">

                {/* Show the chooser heading and close button */}
                <div className="popup__header">
                    <div className="popup__headerLeft">
                        <h2 className="popup__title" id="store-choice-title">Add New Store</h2>
                        <p className="popup__subtitle">Choose where you'd like to sell</p>
                    </div>
                    <div className="popup__headerRight">
                        <button type="button" className="popup__close" onClick={onClose} title="Close" aria-label="Close">
                            <CloseIcon />
                        </button>
                    </div>
                </div>

                {/* Let the seller choose a Strich-hosted Store or an Etsy shop */}
                <div className="store-choice-popup__cards">

                    <button type="button" className="store-choice-popup__card" onClick={onStrich}>
                        <span className="store-choice-popup__logo">
                            <img src="/images/StrichSuite-logo.png" alt="" />
                        </span>
                        <strong>Strich Store</strong>
                        <span className="store-choice-popup__description">Create a hosted Store in StrichSuite</span>
                    </button>

                    <button type="button" className="store-choice-popup__card" onClick={onEtsy} disabled={connectingEtsy}>
                        <span className="store-choice-popup__logo">
                            <img src="/images/etsy-logo.svg" alt="" />
                        </span>
                        <strong>Etsy</strong>
                        <span className="store-choice-popup__description">Connect your Etsy shop</span>
                    </button>

                </div>

            </div>

        </div>

    );

};

export default StoreChoicePopup;